import { useState, useEffect } from 'react';

import { useSelector } from 'src/redux/store';
import { ElementProps } from 'src/@types/forms/types';
import { getFile, getForm, clearFormErrorList } from 'src/redux/slices/formBuilder';

//---------------------------------------------

const useFormData = (formId, setIsLoading) => {
  const [elements, setElements] = useState<ElementProps[]>([]);
  const { form } = useSelector((state) => state.formBuilder);

  const getData = async () => {
    if (formId) {
      try {
        setIsLoading(true);
        await getForm(formId);
        await getFile(formId);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const getElements = async () => {
    clearFormErrorList();
    if (form) {
      const structure = await JSON.parse(form.structure);
      setElements(structure);
    }
  };
  useEffect(() => {
    getData().then();
  }, [formId]);

  useEffect(() => {
    getElements().then();
  }, [form]);

  return { elements, setElements };
};

export default useFormData;
